<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-main style="background: #fafbfc">
    <keep-alive include="DishesManagePage">
      <router-view/>
    </keep-alive>
  </v-main>
</template>

<script>
  export default {
    name: 'DashboardCoreView',
    components: {},
  }
</script>
